import React from 'react';
import {Spin} from 'antd'

export default class LoadSpinner extends React.PureComponent {
  render() {
    return <div className="load-spin-box"><Spin spinning={this.props.show}/></div>;
  }
}
